<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!!prestador"
                    :options="unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!!prestador"
                    :options="infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="model.controlaProtocoloFechamento">
                    Controla protocolo de fechamento
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        unidades() {

            return this.data.form.unidades.filter(u => (this.prestador && u.id === this.prestador.unidadeId)
                || u.infraestruturas.length > this.data.model.prestadoresInternos.filter(p => p.unidadeId === u.id).length)
        },
        infraestruturas() {

            if (!this.model.unidadeId) {

                return []
            }

            return this.data.form.unidades
                .find(u => u.id === this.model.unidadeId)
                .infraestruturas
                .filter(i => (this.prestador && i.id === this.prestador.infraestruturaId)
                    || !this.infraestruturasPrestadorasIds.includes(i.id))
        },
        infraestruturasPrestadorasIds() {

            return this.data.model.prestadoresInternos.map(p => p.infraestruturaId)
        }
    },
    created() {

        if (this.prestador) {

            this.loadPrestador()
        }

        this.addWatchers()
    },
    data: () => ({
        model: {
            id: null,
            controlaProtocoloFechamento: false,
            ativo: true,
            unidadeId: null,
            infraestruturaId: null,
            exames: [],
            procedimentosCirurgicos: [],
            especialidades: [],
        }
    }),
    methods: {
        loadPrestador() {

            Object.assign(this.model, this.prestador)
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.prestador && this.infraestruturaJaAdicionada()) {

                        this.showValidationNotification('O local de atendimento já foi incluído.')

                        return
                    }

                    if (this.prestador) {

                        Object.assign(this.originalPrestador, this.prepareData())
                    }
                    else {

                        this.data.model.prestadoresInternos.push(this.prepareData())
                    }

                    this.$emit('save')
                })
        },
        infraestruturaJaAdicionada() {

            return !!this.data.model.prestadoresInternos.find(p => p.infraestruturaId === this.model.infraestruturaId)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.unidadeNomeFantasia = this.data.form.unidades.find(u => u.id === data.unidadeId).nomeFantasia
            data.infraestruturaNome = this.infraestruturas.find(u => u.id === data.infraestruturaId).nome

            return data
        },
        addWatchers() {

            this.$watch('model.unidadeId', () => {

                this.model.infraestruturaId = null
            })

            this.$watch('infraestruturas', infraestruturas => {

                if (infraestruturas.length === 1) {

                    this.model.infraestruturaId = infraestruturas[0].id
                }
            })
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        originalPrestador: { type: Object },
        prestador: { type: Object },
    },
}
</script>